import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const PlusIcon20 = (props: SvgProps) => <Svg width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
  <Path d='M10 14V10M10 10V6M10 10H14M10 10H6M10 19C7.61305 19 5.32387 18.0518 3.63604 16.364C1.94821 14.6761 1 12.3869 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10C19 12.3869 18.0518 14.6761 16.364 16.364C14.6761 18.0518 12.3869 19 10 19Z' stroke='#0058AD' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
</Svg>;

export default PlusIcon20;
